module.exports = __webpack_public_path__ + "static/media/exploring_fun.1b779100.png";